import React, { Component } from "react";
import { observer } from "mobx-react";
import SettingStore from "../../stores/SettingStore";
import LayerStore from "../../stores/LayerStore";
import { fn_bridge_close, fn_bridge_re_close } from "function/FnPosBridge"

@observer
class EmergnecyNotice extends Component {

    constructor(props) {
        super(props);
        this.rootStore = {
            settingStore: SettingStore,
            layerStore: LayerStore
        }
    }

    done = () => {
        const { rootStore } = this;
        let today = new Date();
        localStorage.setItem("key", "check");
    }

    render() {
        const { rootStore } = this;
        rootStore.layerStore.setLayerLoadingView(false)

        global.fn_pos_emergency_notice = function (data) {
            //초기화
            rootStore.settingStore.setEmergencyNotice("title", "");
            rootStore.settingStore.setEmergencyNotice("content", "");
            rootStore.settingStore.setEmergencyNotice("type", "");
            let jsonData;

            if (data.split('","').length !== 3) {
                jsonData = JSON.parse(data)
            } else {
                let txt1 = data.split('{"title":')
                let txt2 = txt1[1].split(',"content":')
                let txt3 = txt2[1].split('type":')
                jsonData = { "title": txt2[0].replaceAll('"', ''), "content": txt3[0].slice(1, txt3[0].length - 3), "type": txt3[1].replaceAll('"', '').replaceAll('}', '') }
            }
            if (!(data == null || data == "null" || data.trim() == "")) {
                rootStore.settingStore.setEmergencyNotice("title", jsonData.title);
                rootStore.settingStore.setEmergencyNotice("content", jsonData.content);
                rootStore.settingStore.setEmergencyNotice("type", jsonData.type);
            }

            return;
        }

        return (
            <div className="layer_comm layer_common_type layer_open">
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section_emergency">
                            <div className="guide">
                                <h1>
                                    {rootStore.settingStore.getEmergencyNotice.title}
                                </h1>
                            </div>
                            <div className="scroll" id="scroll">
                                <div className="inner">
                                    <p dangerouslySetInnerHTML={{ __html: rootStore.settingStore.getEmergencyNotice.content }}></p>
                                </div>
                            </div>

                            {(rootStore.settingStore.getEmergencyNotice.type === "OKGO_EMERGENCY_NOTICE") ?
                                <button type="button" className="done one" onClick={event => {
                                    fn_bridge_close(rootStore)
                                    document.getElementById("scroll").scrollTo(0, 0);
                                }}>확인했습니다</button>
                                :
                                <>
                                    <button type="button" className="re" onClick={event => {
                                        fn_bridge_close(rootStore)
                                        document.getElementById("scroll").scrollTo(0, 0);
                                    }} >이따 다시 볼게요</button>
                                    <button type="button" className="done" onClick={event => {
                                        fn_bridge_re_close(rootStore)
                                        document.getElementById("scroll").scrollTo(0, 0);
                                    }}>확인했습니다</button>
                                </>
                            }
                        </div>
                        <div className="btn_close" onClick={event => document.getElementById("scroll").scrollTo(0, 0)}>
                            <button type="button"><span className="close">닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default EmergnecyNotice;